import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import HubSpotFormEmbed from './HubSpotFormEmbed';

const HUBSPOT_PORTAL_ID = '51214607';
const HUBSPOT_FORM_ID = '0a27262e-54ab-4cb1-bf22-b21618170e55';
const HUBSPOT_REGION = 'na1';

interface TalkToSalesDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function TalkToSalesDialog({ open, onClose }: TalkToSalesDialogProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Increment key each time the dialog opens to force a fresh HubSpot form mount
  const [mountKey, setMountKey] = useState(0);

  const handleEnter = () => {
    setMountKey(prev => prev + 1);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      TransitionProps={{ onEnter: handleEnter }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >
        Talk to Sales
        <IconButton aria-label="Close" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Fill out the form below and a member of our sales team will be in touch.
        </Typography>
        <HubSpotFormEmbed
          key={mountKey}
          portalId={HUBSPOT_PORTAL_ID}
          formId={HUBSPOT_FORM_ID}
          region={HUBSPOT_REGION}
        />
      </DialogContent>
    </Dialog>
  );
}
